<script>
  import { recordingSaveState } from '../store.js';
  import { retryRecordingSave } from '../../media/recording-service.js';

  $: state = $recordingSaveState;
  $: visible = state.status !== 'idle' && state.status !== 'confirmed';
  $: tone = ['error', 'save_failed'].includes(state.status) ? 'error'
    : state.status === 'saved' ? 'saved'
    : 'working';
</script>

{#if visible}
  <section class="recording-save-panel {tone}" aria-live="polite">
    <div class="save-icon">{tone === 'saved' ? '✓' : tone === 'error' ? '!' : '●'}</div>
    <div class="save-copy">
      <strong>
        {state.status === 'finalizing' ? 'Finalizing full-match video…'
          : state.status === 'saved' ? 'Full-match video saved'
          : state.message || 'Preparing full-match video…'}
      </strong>
      {#if state.fileName}<span>{state.fileName}</span>{/if}
      {#if state.status === 'saved'}<small>Gallery/Downloads me video ready hai.</small>{/if}
      {#if state.contentUri}<small class="gallery-uri">Android Gallery URI: {state.contentUri}</small>{/if}
    </div>
    {#if tone === 'error'}
      <button on:click={retryRecordingSave}>RETRY VIDEO SAVE</button>
    {/if}
  </section>
{/if}

<style>
  .recording-save-panel {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0 12px;
    padding: 12px;
    border: 1px solid #2563eb;
    border-radius: 10px;
    background: rgba(30, 58, 138, .28);
    color: #dbeafe;
  }
  .recording-save-panel.saved { border-color: #16a34a; background: rgba(20, 83, 45, .32); color: #dcfce7; }
  .recording-save-panel.error { border-color: #dc2626; background: rgba(127, 29, 29, .32); color: #fee2e2; }
  .save-icon {
    display: grid;
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    place-items: center;
    border-radius: 50%;
    background: rgba(255,255,255,.12);
    font-weight: 900;
  }
  .working .save-icon { animation: pulse 1s ease-in-out infinite alternate; }
  @keyframes pulse { from { opacity: .35; } to { opacity: 1; } }
  .save-copy { display: flex; min-width: 0; flex: 1; flex-direction: column; gap: 2px; }
  .save-copy strong { font-size: 13px; }
  .save-copy span, .save-copy small { overflow: hidden; color: inherit; opacity: .78; font-size: 10px; text-overflow: ellipsis; white-space: nowrap; }
  button {
    border: 1px solid #fca5a5;
    border-radius: 6px;
    background: #991b1b;
    color: #fff;
    padding: 7px 9px;
    font-size: 10px;
    font-weight: 900;
  }
</style>
